import React from 'react';
import { useAuth } from '../contexts/AuthContext.js';

// Cockpit ne voit plus jamais d'identifiants : c'est Connect qui les collecte.
// Cet écran ne sert qu'aux cas où la redirection auto est volontairement bloquée
// (403 unknown_user, route d'embed /c/:slug, rebond déjà consommé).
const LoginForm = ({ authMessage }) => {
  const { loginWithConnect, loginError } = useAuth();

  return (
    <div className="max-w-md mx-auto mt-4 p-6 bg-white dark:bg-gray-800 rounded-lg shadow-lg">
      <h1 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white">Identification</h1>

      {/* Display authentication message if provided */}
      {authMessage && (
        <div className="mb-4 p-3 bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 rounded-md">
          {authMessage}
        </div>
      )}

      {loginError && (
        <div className="mb-4 p-3 bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-200 rounded-md">
          {loginError}
        </div>
      )}
      <button
        className="bg-blue-500 hover:bg-blue-700 dark:bg-blue-600 dark:hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
        type="button"
        onClick={loginWithConnect}
      >
        Se connecter avec Connect
      </button>
    </div>
  );
};

export default LoginForm;
